import { useMemo } from "react";
import { Document } from "~/api/model";
import logger from "~/utils/logger";

export const useBatchKey = ({
  userId,
  documents,
}: {
  userId: string;
  documents?: Document[];
}) => {
  const sessionBatchKey = useMemo(() => {
    const now = Date.now();
    const oneHourAgo = now - 60 * 60 * 1000;

    const recentDocument = documents?.reduce(
      (latest, doc) => {
        if (!doc.batchKey) return latest;
        const docTime = parseInt(doc.batchKey.split("_")[1]);
        if (!latest || docTime > parseInt(latest.batchKey.split("_")[1])) {
          return doc;
        }
        return latest;
      },
      undefined as Document | undefined
    );

    // If we found a recent document with a batch key less than an hour old, reuse it
    if (recentDocument?.batchKey) {
      const batchKeyTime = parseInt(recentDocument.batchKey.split("_")[1]);
      if (batchKeyTime > oneHourAgo) {
        logger.info("🔄 Reusing existing batch key", {
          batchKey: recentDocument.batchKey,
        });
        return recentDocument.batchKey;
      }
    }

    return `batch_${now}_${userId}`;
  }, [userId, documents]);

  return {
    sessionBatchKey,
  };
};
